import { Component, Input, OnInit } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { BrowserService } from '../browser.service';

@Component({
  selector: 'app-illustration',
  templateUrl: './illustration.component.html',
  styleUrls: ['./illustration.component.scss']
})
export class IllustrationComponent implements OnInit{

  @Input()
  src?:string;

  @Input()
  webpSrc?:string;

  @Input()
  width:number;

  @Input()
  height:number;

  @Input()
  cover:boolean = false;

  noWebp = false;

  thumbSrc?:string;

  constructor(private _lightbox: Lightbox, private browserService: BrowserService) {
    this.browserService.addLoadListener(() => {
      this.noWebp = !this.browserService.supportsWebp();
    });
  }


  ngOnInit() {
    this.thumbSrc = !this.noWebp && this.webpSrc ? this.webpSrc : this.src;
  }

  openLightboxImage = (event) => {
    if(this.src) {
      this._lightbox.open([{
        src: this.thumbSrc,
        thumb: null
      }], 0);
    }
  }

}
